import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import gibletLogo from '@/assets/giblet-logo.png';

export default function DemoCallForDestructionForm() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6">
      <div className="max-w-2xl w-full space-y-8">
        <div className="flex justify-center mb-8">
          <img src={gibletLogo} alt="Giblet Logo" className="h-16 w-auto" />
        </div>

        <div className="text-center space-y-4">
          <h1 className="text-4xl font-bold text-foreground">Call for Destruction (CfD)</h1>
          <p className="text-xl text-muted-foreground">
            Challenge or request removal of knowledge that is outdated, inaccurate, or violates IP
          </p>
        </div>

        <div className="bg-card rounded-lg p-8 shadow-lg space-y-6">
          <div className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">Purpose</h2>
            <p className="text-muted-foreground leading-relaxed">
              A Call for Destruction (CfD) is the platform's quality assurance mechanism for challenging
              knowledge bases that contain outdated information, factual inaccuracies, IP violations,
              plagiarism, or other issues that compromise the integrity of the knowledge network. CfDs
              protect the community by ensuring only validated, accurate knowledge remains active.
            </p>
          </div>

          <div className="space-y-4">
            <h2 className="text-2xl font-semibold text-foreground">CfD Workflow Steps</h2>
            <ol className="list-decimal list-inside space-y-3 text-muted-foreground">
              <li>Classify the issue type (IP violation, inaccuracy, etc.)</li>
              <li>Identify the target KB and provide evidence</li>
              <li>Configure the Destruction Bounty and response window</li>
              <li>Define the requested action and impact assessment</li>
              <li>Assign review team: Reviewer, Respondent, Arbiter (Giblet)</li>
              <li>Review and submit the Call for Destruction</li>
            </ol>
          </div>

          <div className="bg-destructive/10 rounded-lg p-4 space-y-2">
            <h3 className="font-semibold text-foreground">Important:</h3>
            <ul className="space-y-1 text-muted-foreground text-sm">
              <li>• CfDs trigger a 7-day response window for KB owners</li>
              <li>• If upheld: 1% of forfeited tokens go to Giblet, 99% to community</li>
              <li>• False or frivolous CfDs may result in challenger penalties</li>
              <li>• All evidence is permanently recorded on-chain</li>
              <li>• Giblet serves as the default Arbiter for dispute resolution</li>
            </ul>
          </div>
        </div>

        <div className="flex justify-center gap-4">
          <Button variant="outline" onClick={() => navigate('/curt-channel')} className="min-w-[120px]">
            Back
          </Button>
          <Button onClick={() => navigate('/demo-call-for-destruction/issue-type')} className="min-w-[120px]">
            Next
          </Button>
        </div>
      </div>
    </div>
  );
}
